// extracted by mini-css-extract-plugin
export var downArrow = "_7u-0";
export var infoTooltipIcon = "_7u-3";
export var label = "_7u-1";
export var optionCard = "_7u-4";
export var upArrow = "_7u-2";